import { APIError } from '@/data'

const ENTITY_MANAGER_CLOSED_ERROR_FRAGMENT = 'the entitymanager is closed'
const ENTITY_MANAGER_CLOSED_MAX_RETRIES = 3

const sleepAsync = (delayMs: number) => new Promise((resolve) => setTimeout(resolve, delayMs))

export const isEntityManagerClosedError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false
  }

  const candidateMessages = [error.message]
  if (error instanceof APIError && error.errorManagerMessage) {
    candidateMessages.push(error.errorManagerMessage)
  }

  return candidateMessages.some((message) => message?.toLowerCase().includes(ENTITY_MANAGER_CLOSED_ERROR_FRAGMENT))
}

export const runWithEntityManagerClosedRetryAsync = async <T>(
  operation: () => Promise<T>,
  operationName: string,
): Promise<T> => {
  let attempt = 0

  while (true) {
    try {
      return await operation()
    } catch (error) {
      if (attempt >= ENTITY_MANAGER_CLOSED_MAX_RETRIES || !isEntityManagerClosedError(error)) {
        throw error
      }

      attempt += 1
      const delayMs = 300 + Math.floor(Math.random() * 301)
      console.warn(
        `${operationName}: transient backend error detected (entityManager is closed), retrying (${attempt}/${ENTITY_MANAGER_CLOSED_MAX_RETRIES})`,
      )
      await sleepAsync(delayMs)
    }
  }
}
